/* eslint-disable react/prop-types */
import { Avatar, Badge, Box, Button, CircularProgress, Divider, Grid, Stack, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from '../../components/Iconify';
import Scrollbar from '../../components/Scrollbar';
import useSettings from '../../hooks/useSettings';
import { setCurrentItem } from '../../redux/slices/gplx.failSituation.slice';

// ----------------------------------------------------------------------
export default function MenuSection() {
  let theme = useTheme();
  const { themeStretch } = useSettings();
  const [view, setView] = useState("list");
  const { failedSituations, currentItem } = useSelector((state) => state.failSituation);

  return (
    <Box>
      <Stack direction={"row"} spacing={2} mb={1} alignItems={"center"}>
        <Button color='error' onClick={() => setView("list")} size='small' variant={view === 'list' ? 'contained' : 'outlined'} startIcon={<Iconify icon={'material-symbols:list'} />} >
          Chữ
        </Button>
        <Button color='error' onClick={() => setView("grid")} size='small' variant={view === 'grid' ? 'contained' : 'outlined'} startIcon={<Iconify icon={'system-uicons:grid'} />} >
          Số
        </Button>
      </Stack>
      <Divider />
      <Scrollbar sx={{ maxHeight: themeStretch ? 630 : 490 }}>
        <Stack>
          {view === 'list' ? <Stack >
            <Box p={1.5} bgcolor={theme.palette.error.dark} sx={{ borderRadius: 0.5 }}>
              <Typography variant='subtitle2' color={'#fff'}>Câu làm sai khi thi</Typography>
            </Box>
            {failedSituations.map((s) => <SituationItem key={s.id} item={s} currentItem={currentItem} />)}
          </Stack>
            : <Stack spacing={1} >
              <Box p={1.5} bgcolor={theme.palette.error.main} sx={{ borderRadius: 0.5 }}>
                <Typography variant='subtitle2' color={'#fff'}>Câu làm sai khi thi</Typography>
              </Box>
              <Grid container>
                {failedSituations.map((s) => <SituationNumberItem key={s.id} item={s} currentItem={currentItem} />)}
              </Grid>
            </Stack>
          }
        </Stack>
      </Scrollbar>
    </Box>
  );
}

function SituationItem({ item, currentItem }) {
  let theme = useTheme();
  let dispatch = useDispatch();

  const { answerFaileds } = useSelector((state) => state.situation);
  const currentAnswer = answerFaileds?.find(a => a.id === item.id);

  const { title, orderNo } = item;
  const isActive = currentItem?.id === item.id;

  const handleSelect = () => dispatch(setCurrentItem(item));

  return (
    <Stack onClick={handleSelect} direction="row" spacing={2} alignItems="center" bgcolor={theme.palette.background.neutral} my={0.5} py={1.2} sx={{ cursor: 'pointer', borderRadius: 0.5 }} >
      {!isActive && <Badge badgeContent={currentAnswer?.score} color={currentAnswer?.score > 0 ? 'primary' : 'error'} showZero>
        <Avatar sx={{ bgcolor: theme.palette.text.primary, color: theme.palette.background.default }} variant="rounded">{orderNo}</Avatar>
      </Badge>}

      {isActive && <Badge badgeContent={currentAnswer?.score} color={currentAnswer?.score > 0 ? 'primary' : 'error'} showZero>
        <Box sx={{ position: 'relative', display: 'inline-flex', borderRadius: 1, backgroundColor: theme.palette.text.primary }}>
          <CircularProgress />
          <Box sx={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
            <Typography variant="h5" color={theme.palette.background.default}>{orderNo}</Typography>
          </Box>
        </Box>
      </Badge>}
      <Typography variant="subtitle2" color={theme.palette.text.primary} fontWeight={500}>
        {title}
      </Typography>
    </Stack>
  );
}

function SituationNumberItem({ item, currentItem }) {
  let theme = useTheme();
  let dispatch = useDispatch();

  const { answers } = useSelector((state) => state.situation);
  const currentAnswer = answers?.find(a => a.id === item.id);

  const { orderNo } = item;

  const isActive = currentItem?.id === item.id;

  const handleSelect = () => dispatch(setCurrentItem(item));

  return (
    <Grid onClick={handleSelect} item sx={{ cursor: 'pointer', borderRadius: 0.5 }} m={1}>
      {!isActive && <Badge badgeContent={currentAnswer?.score} color={currentAnswer?.score > 0 ? 'primary' : 'error'} showZero>
        <Avatar sx={{ bgcolor: theme.palette.text.primary, color: theme.palette.background.default }} variant="rounded">{orderNo}</Avatar>
      </Badge>}
      {isActive && <Badge badgeContent={currentAnswer?.score} color={currentAnswer?.score > 0 ? 'primary' : 'error'} showZero>
        <Box sx={{ position: 'relative', display: 'inline-flex', borderRadius: 1, backgroundColor: theme.palette.text.primary }}>
          <CircularProgress />
          <Box sx={{ top: 0, left: 0, bottom: 0, right: 0, position: 'absolute', display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
            <Typography variant="h5" color={theme.palette.background.default}>{orderNo}</Typography>
          </Box>
        </Box>
      </Badge>}
    </Grid>
  );
}
